// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class MarketVarianceThresholdOverride {
  readonly marketId: string;
  readonly onTrackVarianceThreshold: string;
  readonly warningVarianceThreshold: string;

  constructor(data: { [key: string]: any } = {}) {
    this.marketId = data.marketId === undefined ? NIL_UUID : data.marketId;
    this.onTrackVarianceThreshold =
      data.onTrackVarianceThreshold === undefined ? '0' : data.onTrackVarianceThreshold;
    this.warningVarianceThreshold =
      data.warningVarianceThreshold === undefined ? '0' : data.warningVarianceThreshold;
  }

  static zero(): MarketVarianceThresholdOverride {
    const zeroValues: ExcludeMethodsDeep<MarketVarianceThresholdOverride> = {
      marketId: NIL_UUID,
      onTrackVarianceThreshold: '0',
      warningVarianceThreshold: '0',
    };
    return new MarketVarianceThresholdOverride(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type MarketVarianceThresholdOverrideWireFormat = {
  marketId: string;
  onTrackVarianceThreshold: string;
  warningVarianceThreshold: string;
};

type NewMarketVarianceThresholdOverrideProps = PartialDeep<
  MarketVarianceThresholdOverride,
  { recurseIntoArrays: true }
>;
export const NewMarketVarianceThresholdOverride: (
  props: NewMarketVarianceThresholdOverrideProps,
) => MarketVarianceThresholdOverride = (props) => new MarketVarianceThresholdOverride(props);

type NewMarketVarianceThresholdOverrideFromWireFormatProps = PartialDeep<
  MarketVarianceThresholdOverrideWireFormat,
  { recurseIntoArrays: true }
>;
export const NewMarketVarianceThresholdOverrideFromWireFormat: (
  props: NewMarketVarianceThresholdOverrideFromWireFormatProps,
) => MarketVarianceThresholdOverride = (props) => new MarketVarianceThresholdOverride(props);
